import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./StructurePage.module.scss";
import { Layout, PageHeader, UnvButton, EmptyState, Icon } from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getStructureDataId } from "../../service/StructureService";
import { setStructureInfoById } from "../../store/slices/StructureSlice";
import StructureTree from "./components/TreeStructure/StructureTree";
import userInfo from "utils/userInfo";

const StructurePage = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const user = userInfo()

  const [data] = useState([]);
  const [render, setRender] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const getData = async () => {
    try {
      let response = await getStructureDataId(data);
      dispatch(
        setStructureInfoById({
          structureInfo: response.data,
        })
      );
    } catch (error) {

    }
  };
  useEffect(() => {
    getData();
  }, [render]);
  const info = useSelector((state) => state.structure.structureInfo);
  useEffect(() => {
    // Wave 4: фактический маршрут — /structure/ (со слешем).
    if (location.pathname === "/structure" || location.pathname === "/structure/") {
      setRender(true);
    }
  }, [location]);

  const isEmpty = info.length === 0

  return (
    <Layout>
      <div className={styles.structure_wrapper}>
        <PageHeader
          icon={<Icon name="building" size={28} />}
          title={isEmpty ? t('structure.page_title') : (title || t('structure.page_title'))}
          subtitle={t('auto.structurepage.subtitle', 'Структура университета: подразделения и сотрудники')}
          actions={isEmpty ? (
            <UnvButton variant="primary" iconLeft="plus" onClick={() => navigate('/add-structure')}>
              {t('structure.create_structure')}
            </UnvButton>
          ) : null}
        />

        <div className={styles.body}>
          {isEmpty ? (
            <EmptyState
              iconName="building"
              title={t('structure.welcome', 'Добро пожаловать')}
              description={user?.firstName ? `${user.firstName}!` : ''}
              action={(
                <UnvButton variant="primary" iconLeft="plus" onClick={() => navigate('/add-structure')}>
                  {t('structure.create_structure')}
                </UnvButton>
              )}
            />
          ) : (
            <StructureTree data={info[0]} setTitle={setTitle} />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default StructurePage;
